import React, {useState, useEffect} from 'react';
import axios from '../Common/axios';
import {Button, Select, Layout, Input, Modal} from "antd";
import {CodeSelect} from '../Common/CodeSelect';
import {postSaveAnalysisCreate, getFindAnalysisList, getFindInfoSuggestListData} from '../Common/api';
import {getNowDate} from '../Common/util';

const {Option} = Select;

/** -------------------------------------------------------------------------- **/
function AnalysisCreate({ p_companyCode, p_companyName, p_assetType, p_assetTypeName, p_assetSpec, p_assetSpecName, onClose }) {

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(p_companyCode);
    const [companyName, setCompanyName] = useState(p_companyName);
    const [assetType, setAssetType] = useState(p_assetType);
    const [assetTypeName, setAssetTypeName] = useState(p_assetTypeName);
    const [assetSpec, setAssetSpec] = useState(p_assetSpec ? [p_assetSpec] : []);
    const [assetSpecName, setAssetSpecName] = useState(p_assetSpecName ? [p_assetSpecName] : []);
    const [reportName, setReportName] = useState('');
    const [reportDesc, setReportDesc] = useState('');
    const [reportOrg, setReportOrg] = useState('');
    const [reportOrgOption, setReportOrgOption] = useState([]);
    const [templateAssetTypes, setTemplateAssetTypes] = useState([]);
    const [uploading, setUploading] = useState(false);
    const titleName="취약점 보고서 생성";

    const onClickCloseHandler = () => {
        //window.close();
        onClose?.(false);
    }

    const onClickSaveHandler = () => {
        
        // 필수조건 체크
        if (companyCode == '' || assetType == '' || reportName == '' || reportOrg == '' ) {
            Modal.info({title: "필수 입력 사항이 없습니다."});
            return;
        }

        setUploading(true);
            axios.post(postSaveAnalysisCreate(), {
                companyCode : companyCode,
                assetType : assetType,
                assetSpec : assetSpec, // 배열로 전송
                reportName : reportName,
                reportDesc : reportDesc,
                reportOrg : reportOrg
            }, {logCompany : companyCode, logParam : reportName})
            .then((response) => {
                // console.dir(response);
                setUploading(false);
                //Modal.info({title: "OK.", okText:"Close"});
                if(response.data.status == 'success') {
                    Modal.info({title:titleName, content:response.data.report_id+" 취약점 보고서가 생성되었습니다.", okText:"Close", onOk() {
                        //정상적으로 생성된 경우, 부모창을 재조회하고 팝업창을 닫는다.
                        //window.close();
                        onClose?.(true);
                    }});
                } else {
                    Modal.info({title:titleName, content:response.data, okText:"Close"});  
                }
            })
            .catch((error) => {
                setUploading(false);
                // console.dir(error);
                Modal.error({title:titleName, content:error.response.data.message, okText:"Close"});  
            });
    };

    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        
        setAssetType(value);
       const typeName = option.children.props.children.length > 3 ? option.children.props.children[3] : option.children.props.children[2];
       // select box의 label 값을 가져올 때는 아래처럼 현재는 "[코드] 이름" 으로 되어있음 
        // const typeName2 = typeof option.children === "string" ? option.children : option.children.props?.children;
        setAssetTypeName(typeName);        
        // setAssetTypeName(option.children[2]);
        
        // 자산유형이 변경되면 자산스펙 초기화
        setAssetSpec([]);
        setAssetSpecName([]);
    };

    // 자산스펙 변경 (멀티셀렉트)
    const onChangeAssetSpec = (values) => {
        setAssetSpec(values);
        // 멀티셀렉트에서는 선택된 옵션들의 텍스트를 별도로 관리
        // 실제로는 values 배열로만 관리해도 충분할 수 있음
        setAssetSpecName(values);
    };

    // 생성기준 변경
    const onChangeReportOrg = (value) => {
        setReportOrg(value);
        // 선택된 템플릿의 권고사항에서 자산유형 추출
        if (value) {
            fetchTemplateAssetTypes(value);
        } else {
            setTemplateAssetTypes([]);
        }
    };
    
    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "reportName") {
            setReportName(event.target.value);
        } else if (event.target.id == "reportDesc") {
            setReportDesc(event.target.value);
        } 
    };

    // 취약점분석 제목
    useEffect(() => {
        setReportName('[' + getNowDate('-') + '] ' + companyName + ' (' + assetTypeName + ')');
    }, [companyCode, assetType]);
    
    // 복사대상 레포트 조회
    useEffect(() => {
        findReportOrg(assetType);
    }, [assetType]);

    const findReportOrg = (assetType) => {
        //자동조회
        if(assetType != '') {
            //getFindAnalysisList(companyCode, assetType, reportName, startYmd, endYmd)
            axios.get(getFindAnalysisList('TMPL', assetType, '', '', ''))
                .then((response) => {
                    //console.log(response);
                    setReportOrg("");
                    setReportOrgOption(response.data);
                })
                .catch((error) => {
                    console.log("AnalysisCreate.sj --- 113 error");
                    console.dir(error);
                });
        }
    }

    // 선택된 템플릿의 권고사항에서 자산유형 추출
    const fetchTemplateAssetTypes = (templateReportId) => {
        axios.get(getFindInfoSuggestListData(templateReportId))
            .then((response) => {
                // 권고사항 데이터에서 asset_spec 추출하여 중복 제거
                const assetTypes = [...new Set(
                    response.data
                        .map(item => item.asset_spec)
                        .filter(spec => spec && spec.trim() !== '')
                )].sort();

                setTemplateAssetTypes(assetTypes);
            })
            .catch((error) => {
                console.log("AnalysisCreate.js --- fetchTemplateAssetTypes error");
                console.dir(error);
                setTemplateAssetTypes([]);
            });
    }

    return (
    <div className='layer_overlay'>
        <div className='layer_wrap'>
            <div className='popup_header'>
                <div className='popup_title'>
                    취약점분석 등록
                </div>
            </div>
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'20%'}} />
                        <col />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>{ p_companyCode ? (
                                    <Select id="companyCode" value={companyCode}
                                            size="small"
                                            style={{width: "80%"}}
                                            disabled={true}
                                        >
                                        <Option key={companyCode} value={companyCode} title={'['+companyCode+'] ' + companyName}>{'['+companyCode+']'} {companyName}</Option>
                                    </Select>
                                ) : (<CodeSelect codeType="com_cd" 
                                                value={companyCode}
                                                disabled={p_companyCode?true:false}
                                                onChangeHandler={onChangeCompanyCode}
                                    />  
                                )}
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                                        showCompanyIndicator={true}
                                        selectedCompanyCode={companyCode}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>자산스펙</th>
                        <td>
                            <CodeSelect codeType="asset_spec"
                                        value={assetSpec}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetSpec}
                                        parentCode={assetType}
                                        multiple={true}
                                        useActualAssets={true}
                                        selectedCompanyCode={companyCode}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>취약점분석 제목</th>
                        <td>
                            <Input id="reportName" size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportName}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    {/* <tr>
                        <th><span className='req'>*</span>자산 유형</th>
                        <td>

                        </td>
                    </tr> */}
                    <tr>
                        <th>취약점분석 설명</th>
                        <td>
                            <Input id="reportDesc" size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportDesc}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>복사대상 분석기준</th>
                        <td>
                        <Select id="reportOrg"
                                    size="small"
                                    style={{width: "80%"}}
                                    value={reportOrg}
                                    onChange={onChangeReportOrg}
                            >
                                {reportOrgOption.length > 0 &&
                                    reportOrgOption.map((item, i) => {
                                        return (
                                            <Option key={i} value={item.report_id} title={`${item.report_nm}(${item.report_id})`}>{item.report_nm}({item.report_id})</Option>
                                        )
                                    })}
                            </Select>
                            <div style={{marginTop: '8px'}}>- 복사대상 보고서의 분석기준(진단항목,대응방안,위협)이 자동으로 복사됩니다.</div>
                            {templateAssetTypes.length > 0 && (
                                <div style={{marginTop: '10px'}}>
                                    <div style={{marginBottom: '5px', fontWeight: 'bold', color: '#0378c7'}}>템플릿 포함 자산유형:</div>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
                                        {templateAssetTypes.map((assetType, index) => (
                                            <span key={index} style={{
                                                backgroundColor: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                borderRadius: '4px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                color: '#0050b3'
                                            }}>
                                                {assetType}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className="popup_button_close">
                    <Button
                        type="primary"
                        onClick={onClickSaveHandler}
                        loading={uploading}
                        style={{marginRight: '10px'}}
                    >
                        {'저장'}
                    </Button>
                    <Button
                        type="default"
                        onClick={onClickCloseHandler}
                        style={{marginLeft: '10px'}}
                    >
                        {'닫기'}
                    </Button>
            </div>
        </div>
    </div>
    );
}
export default AnalysisCreate;